module.exports = __webpack_public_path__ + "299789057429039750a3e3074209ee40.svg";